package models

import kotlinx.serialization.Serializable

@Serializable
data class IdentifyTextRequest(
    val description: String,
    val language: String = "ru",
)

@Serializable
data class IdentifyTextResponse(
    val candidates: List<IdentifyCandidateDto> = emptyList(),
)

@Serializable
data class IdentifyCandidateDto(
    val video: VideoDetails,
    val confidence: Double = 0.0,
    val reason: String = "",
    val year: String? = null,
    val episodeHint: String? = null,
)
